<template>
    <div
		class="my-modal"
		:class="{
			'fade-out': fadeOut
		}"
		v-if="isHidden"
		@click.self="hideModal"
	>
		<slot :hideModal="hideModal"></slot>
	</div>
</template>

<script>

export default {
	name: 'v-modal',
	props: {
		modal: {
			type: Boolean,
			default: false
		},
	},
	data() {
		const isShow = this.modal;
		return {
			isHidden: isShow,
			fadeOut: true,
		}
	},
	methods: {
		hideModal() {
			this.fadeOut = true;
			setTimeout(() => {
				this.isHidden = false;
				this.$emit('hide-modal')
			}, 300);
		}
	},
	watch: {
		modal(bool) {
			this.isHidden = bool;
			setTimeout(() => {
				this.fadeOut = !bool;
			}, 10);
		}
	},
	mounted() {
		setTimeout(() => {
			this.fadeOut = !this.isHidden;
		}, 10);
	},
}

</script>

<style lang="scss">

.my-modal {
	@apply fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center bg-[#00000059] z-10 transition-all duration-300;
	> * {
		@apply transition-all duration-300;
	}
	&.fade-out {
		opacity: 0;
		pointer-events: none;
		& > * {
			opacity: 0;
			transform: translateY(-20%);
		}
	}
}

</style>
